<template>
  <div class="page_salary">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="whitelistQuery" class="re_down_form" label-width="88px" size="small">
            <el-form-item label="项目" size="small">
              <el-select v-model="whitelistQuery.projectId" placeholder="" clearable size="small" style="width:180px">
                <el-option v-for="x in projectList" :key="x.Id" :label="x.ProjectName" :value="x.Id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="状态" size="small">
              <el-select v-model="whitelistQuery.statu" placeholder="" clearable size="small" style="width:140px">
                <el-option label="启用" value="启用"></el-option>
                <el-option label="停用" value="停用"></el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="top-right">
        <el-button type="primary" size="small" @click="whitelistSearch" style="margin-right:20px;">搜 索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>薪酬</el-breadcrumb-item>
          <el-breadcrumb-item>配置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <el-tabs v-model="activeName" @tab-click="changeTab">
          <el-tab-pane label="发放途径配置" name="0"></el-tab-pane>
          <el-tab-pane label="签约校验白名单" name="1">
          </el-tab-pane>
        </el-tabs>
        <div class="ftabBtn flex">
          <el-button type="primary" size="small" @click="addCompany" v-if="activeName === '0'">+新增落地公司</el-button>
          <template v-if="activeName === '1'">
            <el-button type="primary" size="small" @click="openAddWhitelist">新增+</el-button>
            <!-- <el-button type="warning" size="small" @click="batchEnable">批量启用</el-button>
            <el-button type="info" size="small" @click="batchDisable">批量禁用</el-button>
            <el-button size="small" @click="exportWhitelist">导出</el-button> -->
          </template>
        </div>
        <el-table :data="tableData" border class="doc_table" v-loading="loading" style="width:1201px" v-if="activeName === '0'">
          <el-table-column prop="ChannelName" label="途径名称" width="100" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="Account" label="平台" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="CompanyNameOptional" label="落地公司" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="CollectionOrder" label="收款抬头" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="DueBank" label="收款银行" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="BankBranch" label="开户行" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="ShroffAccount" label="收款账号" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="StateStr" label="费率" width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope={row}>
              {{ row.Rate.r1 ? '实发金额 ≤' + row.Rate.a1 + '=' + row.Rate.r1  + '；': ''}}{{ row.Rate.r2 ? row.Rate.a21 + '≤ 实发金额 ≤' + row.Rate.a22 + '=' + row.Rate.r2 + '；' : ''}}{{ row.Rate.r3 ? '实发金额 ≥' + row.Rate.a3 + '=' + row.Rate.r3  : ''}}
            </template>
          </el-table-column>
          <el-table-column prop="RechargeMethod" label="打款方式" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="StateStr" label="启用状态" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="Remark" label="备注" width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center" fixed="right" width="100px">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-popconfirm :title="row.StateStr=='启用' ? '请确定是否停用？' : '请确定是否启用？'" @confirm="stopHandle(row)" style="margin-right: 10px;">
                  <el-button type="text" slot="reference">{{row.StateStr=='启用' ? '停用' : '启用'}}</el-button>
                </el-popconfirm>
                <el-button type="text" @click="edit(row)">修改</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <template v-if="activeName === '1'">
          <el-table :data="whitelistData" border size="small" v-loading="whitelistLoading" style="width:100%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="48" align="center"></el-table-column>
            <!-- <el-table-column prop="ProjectId" label="项目ID" min-width="140" align="center"></el-table-column> -->
            <el-table-column prop="proName" label="项目名称" min-width="180" :show-overflow-tooltip="true" align="center"></el-table-column>
            <el-table-column label="状态" min-width="100" align="center">
              <template slot-scope="{row}">
                <el-tag :type="row.statu === '启用' ? 'success' : 'info'" size="mini">{{ row.statu === '启用' ? '启用' : '停用' }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="更新时间" min-width="160" align="center">
              <template slot-scope="{row}">{{ formatTime(row.upTime) }}</template>
            </el-table-column>
            <el-table-column label="操作" width="140" align="center">
              <template slot-scope="{row}">
                <div class="injuryTabBtn">
                  <el-button type="text" size="small" @click="toggleWhitelist(row)">{{ row.statu === '启用' ? '停用' : '启用' }}</el-button>
                  <el-button type="text" size="small" class="danger-btn" @click="deleteWhitelist(row)">删除</el-button>
                </div>
              </template>
            </el-table-column>
            <template slot="empty">
              <span class="muted">暂无数据</span>
            </template>
          </el-table>
          <div class="block whitelist-pagination">
            <el-pagination v-if="whitelistTotal > 0" @current-change="whitelistPageChange" :current-page.sync="whitelistQuery.pagination.Page" :page-size="whitelistQuery.pagination.PageSize" layout="total, prev, pager, next, jumper" :total="whitelistTotal"></el-pagination>
          </div>
        </template>
      </div>
    </div>

    <el-dialog title="新增发放途径" :visible.sync="showAddRoad" width="500px">
      <el-form :model="formData" ref="formData" :rules="rules" label-width="100px">
        <el-form-item label="途径名称" prop="name">
          <el-input v-model="formData.name" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="平台" prop="name">
          <el-input v-model="formData.name" style="width:300px" size="small"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddRoad = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="showAddRoad = false">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="新增落地公司" :visible.sync="showAddCompany" width="1000px">
      <el-form :model="formData" :inline="true" ref="formData" :rules="rules" label-width="100px">
        <el-form-item label="途径名称">
          <!-- <div class="formItem">XXX</div> -->
          <el-input v-model="formData.model.ChannelName" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="平台">
          <el-input v-model="formData.model.name" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="落地公司" prop="CompanyNameOptional">
          <el-input v-model="formData.model.CompanyNameOptional" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="收款抬头" prop="CollectionOrder">
          <el-input v-model="formData.model.CollectionOrder" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="收款银行" prop="DueBank">
          <el-input v-model="formData.model.DueBank" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="开户行" prop="BankBranch">
          <el-input v-model="formData.model.BankBranch" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="收款账号" prop="ShroffAccount">
          <el-input v-model="formData.model.ShroffAccount" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="打款方式" prop="RechargeMethod">
          <el-input v-model="formData.model.RechargeMethod" style="width:300px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="费率">
          <div class="flex aic">

            <el-input v-model="formData.RateJ.r1" placeholder="费率" style="width:100px;" size="small"></el-input>

            <div class="condition"> 条件</div>
            <div class="rate flex aic">
              <div class="symbol sfje">实发金额 ≤</div>
              <el-input v-model="formData.RateJ.a1" style="width:100px;" size="small"></el-input>

            </div>
            <div class="injuryTabBtn" style="margin-left: 20px;">
              <!-- <el-button type="text" @click="delRateItem">删除</el-button> -->
              <!-- <el-button type="text" @click="addRateItem">增加</el-button> -->
            </div>
          </div>
          <div class="flex aic">
            <el-input v-model="formData.RateJ.r2" placeholder="费率" style="width:100px;" size="small"></el-input>
            <div class="condition"> 条件</div>
            <div class="rate flex aic">
              <el-input v-model="formData.RateJ.a21" style="width:100px;" size="small"></el-input>
              <div class="symbol sfje">≤ 实发金额 ≤</div>
              <el-input v-model="formData.RateJ.a22" style="width:100px;" size="small"></el-input>
              <!-- <div class="symbol"> = </div> -->

            </div>
          </div>
          <div class="flex aic">
            <el-input v-model="formData.RateJ.r3" placeholder="费率" style="width:100px;" size="small"></el-input>
            <div class="condition"> 条件</div>
            <div class="rate flex aic">
              <div class="symbol sfje">实发金额 ≥</div>
              <el-input v-model="formData.RateJ.a3" style="width:100px;" size="small"></el-input>
              <!-- <div class="symbol"> = </div> -->

            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddCompany = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmAddCompany">提 交</el-button>
      </span>
    </el-dialog>

    <!-- 新增白名单项目弹窗 -->
    <el-dialog title="新增白名单项目" :visible.sync="whitelistDialogVisible" width="500px" class="res_dialog">
      <el-form :model="whitelistForm" :rules="whitelistRules" ref="whitelistForm" label-width="100px" size="small">
        <el-form-item label="选择项目" prop="projectId">
          <el-select v-model="whitelistForm.projectId" placeholder="下拉选择" style="width:100%" filterable @change="changeProject">
            <el-option v-for="(item, index) in projectList" :key="index" :label="item.StrprojectName" :value="item.Projectid">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="whitelistForm.statu" style="width:100%">
            <el-option label="启用" value="启用"></el-option>
            <el-option label="停用" value="停用"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="whitelistDialogVisible = false">取消</el-button>
        <el-button type="primary" size="small" @click="confirmAddWhitelist" :loading="whitelistSaving">确定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        listQuery: {
          ChannelName: '',
          pageNum: 1,
          pageSize: 10,
        },
        roletype: localStorage.loginRoletype,
        activeName: 0,
        totalCount: 0,
        loading: false,
        tableData: [],
        formData: {
          model: {
            Id: '',
            ChannelName: '', //渠道名称
            CompanyNameOptional: '', //落地公司名称选填
            RechargeMethod: '', //打款充值方式
            CollectionOrder: '', //收款抬头
            DueBank: '', //收款银行
            ShroffAccount: '', //收款账号
            BankBranch: '', //开户支行
            DisableorNot: '启用', //是否停用
          },
          RateJ: {
            a1: '',
            r1: '',
            a21: '',
            a22: '',
            r2: '',
            a3: '',
            r3: '',
          }, //费率
        },
        rules: {
          name: {
            required: true,
            message: '请输入',
            trigger: 'blur'
          },
        },
        showAddRoad: false, //新增途径弹窗
        showAddCompany: false, //新增落地公司弹窗
        whitelistQuery: {
          "pageModel": {
            "rows": 10,
            "page": 1,
            "orderInput": [],
          },
          "proName": "",
          "statu": '',
          "busiType": 5
        },
        whitelistLoading: false,
        whitelistData: [],
        whitelistTotal: 0,
        whitelistDialogVisible: false,
        whitelistSaving: false,
        whitelistForm: {
          projectId: '',
          proName: '',
          statu: '启用',
          id: ''
        },
        whitelistRules: {
          projectId: [{
            required: true,
            message: '请选择项目',
            trigger: 'change'
          }],
          status: [{
            required: true,
            message: '请选择状态',
            trigger: 'change'
          }]
        },
        whitelistSelection: [],
        projectList: [],
      }
    },
    created() {
      this.getDistributionChannelList();
      this.loadProjectOptions();
      // this.loadWhitelistPage();
    },
    methods: {
      checkPermission,
      changeTab() {
        if (this.activeName == '0') {
          this.getDistributionChannelList();
        } else {
          this.loadWhitelistPage();
        }
      },
      currentChange(val) {
        this.listQuery.pageNum = Number(val);
        this.getDistributionChannelList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getDistributionChannelList();
      },
      //发放途径列表
      getDistributionChannelList() {
        xz.getDistributionChannelList(this.listQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            res.data.data.forEach(element => {
              element.Rate = JSON.parse(element.Rate);
            });
            this.tableData = res.data.data;
            this.totalcount = res.data.totalcount;
          } else {
            this.$message.error('保存失败');
          }
        })
      },
      stopHandle(row) {
        let stopForm = {
          type: type, // 1到款银行 2 开票抬头 3发薪主体 4\发放途径
          StateStr: row.StateStr == '启用' ? '停用' : '启用', //状态
          id: row.Id,
        }
        xz.updataCollectingBankstateStr(stopForm, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$message.success('保存成功');
            this.getDistributionChannelList();
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      addCompany() {
        this.formData = {
          model: {
            ChannelName: '', //渠道名称
            CompanyNameOptional: '', //落地公司名称选填
            RechargeMethod: '', //打款充值方式
            CollectionOrder: '', //收款抬头
            DueBank: '', //收款银行
            ShroffAccount: '', //收款账号
            BankBranch: '', //开户支行
            DisableorNot: '', //是否停用
          },
          RateJ: {
            a1: '',
            r1: '',
            a21: '',
            a22: '',
            r2: '',
            a3: '',
            r3: '',
          } //费率
        }
        this.showAddCompany = true;
      },
      edit(row) {
        this.formData.model = row;
        this.formData.RateJ = row.Rate;
        this.formData.model.Rate = '';
        this.showAddCompany = true;
      },
      confirmAddCompany() {
        xz.addDistributionChannel(this.formData, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.$message.success('保存成功');
            this.getDistributionChannelList();
            this.showAddCompany = false;
          } else {
            this.$message.error('保存失败');
          }
        })
      },
      changeProject(val) {
        let item = this.projectList.find(e => e.Projectid == val);
        this.whitelistForm.proName = item.StrprojectName || '';
      },
      formatTime(v) {
        if (!v) return '-';
        let d = v instanceof Date ? v : new Date(v);
        if (isNaN(d.getTime())) return v;
        let pad = n => (n < 10 ? '0' + n : '' + n);
        return d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate()) + ' ' + pad(d.getHours()) + ':' + pad(d.getMinutes()) + ':' + pad(d.getSeconds());
      },
      loadProjectOptions() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: localStorage.loginRoletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.projectList = res.msg;
          }
        });

      },
      loadWhitelistPage() {
        console.log('loadWhitelistPage');
        this.whitelistLoading = true;
        xz.ArdCurStat(this.whitelistQuery, 'GetPaySingWhiteValidPageList').then(res => {
          if (res && res.status === 'ok') {
            this.whitelistData = res.data.data;
            this.whitelistTotal = res.data.pageModel.totalcount;
          } else {
            this.whitelistData = [];
            this.whitelistTotal = 0;
          }
          this.whitelistLoading = false;
        });
      },
      whitelistSearch() {
        this.whitelistQuery.pageModel.page = 1;
        this.loadWhitelistPage();
      },
      whitelistPageChange(val) {
        this.whitelistQuery.pageModel.page = Number(val);
        this.loadWhitelistPage();
      },
      handleSelectionChange(rows) {
        this.whitelistSelection = rows || [];
      },
      openAddWhitelist() {
        this.whitelistForm = {
          projectId: '',
          proName: '',
          statu: '启用',
          id: ''
        };
        this.whitelistDialogVisible = true;
        this.$nextTick(() => {
          if (this.$refs.whitelistForm) this.$refs.whitelistForm.clearValidate();
        });
      },
      confirmAddWhitelist() {
        this.whitelistSaving = true;
        xz.ArdCurStat(this.whitelistForm, 'AddDelUpPaySingWhiteValid').then(res => {
          if (res && res.status === 'ok') {
            this.$message.success('操作成功');
            this.loadWhitelistPage();
            this.whitelistDialogVisible = false;
            this.whitelistSaving = false;
          } else {
            this.whitelistSaving = false;
            this.$message.error(res.msg || '操作失败');
          }
        });
      },
      toggleWhitelist(row) {
        let d = {
          id: row.id,
          proName: row.proName,
          statu: row.statu == '启用' ? '停用' : '启用',
          projectId: row.projectId,
        };
        xz.ArdCurStat(d, 'AddDelUpPaySingWhiteValid').then(res => {
          if (res && res.status === 'ok') {
            this.$message.success('操作成功');
            this.loadWhitelistPage();
          } else {
            this.$message.error(res.msg || '操作失败');
          }
        });
      },
      deleteWhitelist(row) {
        if (!confirm('确定删除该白名单项目吗？')) return;
        xz.ArdCurStat({
          id: row.id,
          isDelete: 1
        }, 'AddDelUpPaySingWhiteValid').then(res => {
          if (res && res.status === 'ok') {
            this.$message.success('操作成功');
            this.loadWhitelistPage();
          } else {
            this.$message.error(res.msg || '操作失败');
          }
        });
      },
      batchEnable() {
        if (!this.whitelistSelection.length) {
          this.$message.warning('请先选择记录');
          return;
        }
        this.whitelistSelection.forEach(row => {
          row.Status = 1;
        });
        this.$message.success('批量启用成功');
      },
      batchDisable() {
        if (!this.whitelistSelection.length) {
          this.$message.warning('请先选择记录');
          return;
        }
        this.whitelistSelection.forEach(row => {
          row.Status = 0;
        });
        this.$message.success('批量禁用成功');
      },
      exportWhitelist() {
        if (!this.whitelistData.length) {
          this.$message.warning('没有可导出的数据');
          return;
        }
        let headers = ['项目ID', '项目名称', '状态', '更新时间'];
        let rows = this.whitelistData.map(r => [
          r.ProjectId,
          r.ProjectName,
          r.Status === 1 ? '启用' : '停用',
          this.formatTime(r.UpdateTime)
        ]);
        let csv = '\uFEFF' + headers.join(',') + '\n' + rows.map(r => r.map(v => '"' + String(v).replace(/"/g, '""') + '"').join(',')).join('\n');
        let blob = new Blob([csv], {
          type: 'text/csv;charset=utf-8'
        });
        let url = URL.createObjectURL(blob);
        let a = document.createElement('a');
        a.href = url;
        a.download = '签约校验白名单_' + new Date().getTime() + '.csv';
        a.click();
        URL.revokeObjectURL(url);
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .roadBox {
    // width: 1050px;
    overflow-x: auto;
  }

  .headLine {
    margin-bottom: 15px;
  }

  .titleItem {
    min-width: 110px;
    text-align: center;
    margin-right: 10px;
  }

  .content {
    background: #E8F7F7;
    padding: 12px 0px;
    width: 1440px;
    margin-top: 20px;
  }

  .contentLine {
    margin-bottom: 10px;
  }

  .contentItem {
    min-width: 110px;
    text-align: center;
    margin-right: 10px;
  }

  .formItem {
    width: 300px;
  }

  .rate {
    height: 40px;
    line-height: 40px;
  }

  .sfje {
    width: 80px;
  }

  .symbol {
    color: #000;
    height: 32px;
    line-height: 32px;
    margin: 0 10px;
  }

  .condition {
    color: #606266;
    margin: 0 10px 0 50px;
  }
</style>
<style>
  .page_salary .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_salary .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_salary .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_salary .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_salary .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_salary .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
</style>